import axios from 'axios';

export class SettingsService {
    public getAllSettings() {
        return axios.get( '/api/settings' );
    }

    public setAllSettings( settings: any ) {
        return axios.post( '/api/settings', settings );
    }
}